import React, { useEffect } from "react";
import "./searchInput.scss";

import SearchIcon from "@mui/icons-material/Search";

import { InputGroup, Form } from "react-bootstrap";
import { t } from "i18next";
import { isEmpty } from "../../utils/validation";

const SearchInput = ({ search, setSearch, searchFunction }) => {
  useEffect(() => {
    if (isEmpty(search)) searchFunction();
  }, [search]);

  return (
    <div className="search-input">
      <InputGroup>
        <Form.Control
          type="text"
          placeholder={t("common.search")}
          aria-describedby="search-icon"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              searchFunction();
            }
          }}
        />
        <InputGroup.Text id="search-icon">
          <div
            onClick={(e) => {
              e.preventDefault();
              searchFunction();
            }}
          >
            <SearchIcon className="search-icon-material-ui" />
          </div>
        </InputGroup.Text>
      </InputGroup>
    </div>
  );
};

export default SearchInput;
